import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Flame, Phone } from "lucide-react";
import { ORDER_URL } from "@/components/Navbar";

const BG_IMG =
  "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?q=80&w=1920&auto=format&fit=crop";

const OrderBand = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-14%", "14%"]);

  return (
    <section
      ref={ref}
      data-testid="order-band-section"
      className="relative overflow-hidden bg-navy grain py-28 sm:py-40"
    >
      <motion.div className="absolute inset-0" style={{ y: bgY }}>
        <img
          src={BG_IMG}
          alt=""
          aria-hidden="true"
          className="h-[130%] w-full object-cover opacity-25"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1128] via-transparent to-[#0A1128]" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 sm:px-10 text-center">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-script text-gold text-2xl sm:text-3xl"
        >
          hungry already?
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mt-4 font-heading font-semibold tracking-tight leading-[1.02] text-cream text-5xl sm:text-6xl lg:text-7xl"
        >
          The tandoor is <span className="text-gold italic">lit.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.25, duration: 0.8 }}
          className="mt-6 text-cream/70 text-base sm:text-lg font-light max-w-xl mx-auto"
        >
          Order ahead for pickup or delivery — your feast will be hot, fresh and
          waiting.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.35, duration: 0.8 }}
          className="mt-10 flex flex-wrap justify-center items-center gap-5"
        >
          <motion.a
            data-testid="order-band-cta-btn"
            href={ORDER_URL}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ y: -3, boxShadow: "0 18px 50px rgba(198,40,40,0.55)" }}
            whileTap={{ scale: 0.97 }}
            className="flex items-center gap-3 bg-spice text-cream font-semibold text-lg sm:text-xl px-11 py-5 rounded-full"
          >
            <Flame size={22} />
            Order Online Now
          </motion.a>
          <a
            data-testid="order-band-phone-link"
            href="tel:+61408382360"
            className="flex items-center gap-2.5 text-cream/85 hover:text-gold border border-cream/30 hover:border-gold/60 transition-colors duration-300 px-8 py-5 rounded-full text-lg"
          >
            <Phone size={19} />
            +61 408 382 360
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default OrderBand;
